/**
 * ID anónimo y persistente del visitante (localStorage `visitor_id`).
 * Lo comparten `page_visits` (VisitTracker) y `site_events` (trackSiteEvent)
 * para poder unir visitas y conversiones del mismo navegador.
 * Solo browser: devuelve '' si no hay `window`/localStorage disponible.
 */
export function getVisitorId(): string {
  if (typeof window === 'undefined') return '';
  try {
    const storedId = localStorage.getItem('visitor_id');
    if (storedId) return storedId;

    const newId = crypto.randomUUID();
    localStorage.setItem('visitor_id', newId);
    return newId;
  } catch {
    // localStorage bloqueado (modo privado / cookies deshabilitadas)
    return '';
  }
}
